import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navigation from "./Navigation";
import Footer from "./Footer";
import LightRays from "./LightRays";

const HomePage = () => {

  return (
    <div className="min-h-screen bg-black relative overflow-hidden">
      {/* Light Rays Background */}
      <div className="fixed inset-0 w-full h-full" style={{ zIndex: 1 }}>
        <LightRays
          raysOrigin="top-center"
          raysColor="#00ff41"
          raysSpeed={1.5}
          lightSpread={0.8}
          rayLength={2.5}
          fadeDistance={2.0}
          followMouse={true}
          mouseInfluence={0.1}
          noiseAmount={0.1}
          distortion={0.05}
          className="custom-rays"
        />
      </div>
      
      {/* Creepy Background Elements */}
      <div className="absolute inset-0 opacity-10" style={{ zIndex: 2 }}>
        <div className="absolute top-20 left-10 w-32 h-32 border border-green-500 rounded-full animate-beetlejuice-pulse"></div>
        <div className="absolute top-40 right-20 w-24 h-24 border border-green-400 rounded-full animate-beetlejuice-pulse" style={{ animationDelay: "1s" }}></div>
        <div className="absolute bottom-20 left-1/4 w-16 h-16 border border-green-600 rounded-full animate-beetlejuice-pulse" style={{ animationDelay: "2s" }}></div>
        <div className="absolute top-1/2 right-1/3 w-20 h-20 border border-green-300 rounded-full animate-beetlejuice-pulse" style={{ animationDelay: "3s" }}></div>
      </div>

      {/* Navigation */}
      <div style={{ position: 'relative', zIndex: 10 }}>
        <Navigation />
      </div>

      {/* Hero Section */}
      <section className="relative overflow-hidden" style={{ position: 'relative', zIndex: 10 }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20">
          <div className="text-center">
            <h1 className="text-5xl md:text-7xl font-black text-green-400 mb-6 animate-fade-in drop-shadow-2xl">
              FAKULTA STRAŠIDEL – BEETLEJUICE, BEETLEJUICE, BEETLE …
            </h1>
            <div className="text-4xl md:text-5xl text-green-300 mb-8 font-black animate-beetlejuice-pulse drop-shadow-2xl">
              IT'S SHOWTIME
            </div>
            <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto animate-slide-up leading-relaxed">
              Fakulta se na jeden den mění v záhrobí, kterým vás bude provázet Beetlejuice. Vstup portálem. Splň úkoly. Seber razítka. Odhal heslo. Dokážeš splnit všechny úkoly a uniknout ze záhrobí do světa živých?
            </p>
            {/* Event Details Section */}
            <div className="text-center mb-8">
              <div className="grid md:grid-cols-3 gap-6 max-w-5xl mx-auto">
                <div className="bg-green-800/30 rounded-2xl p-6 border border-green-600/50 hover:bg-green-800/40 transition-all duration-300">
                  <div className="text-4xl mb-4">🕐</div>
                  <div className="text-green-400 font-bold text-2xl mb-3">Kdy</div>
                  <div className="text-gray-200 text-lg">7.11.2025</div>
                  <div className="text-green-300 font-semibold text-xl">15:00 – 20:00</div>
                </div>
                
                <div className="bg-green-800/30 rounded-2xl p-6 border border-green-600/50 hover:bg-green-800/40 transition-all duration-300">
                  <div className="text-4xl mb-4">📍</div>
                  <div className="text-green-400 font-bold text-2xl mb-3">Kde</div>
                  <div className="text-gray-200 text-lg">Fakulta aplikované informatiky</div>
                  <div className="text-gray-200 text-lg">Univerzita Tomáše Bati</div>
                  <div className="text-green-300 font-semibold text-base">Nad Stráněmi 4511, 760 05 Zlín 5</div>
                </div>
                
                <div className="bg-green-800/30 rounded-2xl p-6 border border-green-600/50 hover:bg-green-800/40 transition-all duration-300">
                  <div className="text-4xl mb-4">🎫</div>
                  <div className="text-green-400 font-bold text-2xl mb-3">Vstup</div>
                  <div className="text-green-300 font-semibold text-xl">Zdarma</div>
                  <div className="text-gray-300 text-lg">/ dobrovolné vstupné</div>
                </div>
              </div>
            </div>
            
            {/* Summoning Section */}
            <div className="text-center mb-12 py-8">
              <p className="text-2xl md:text-3xl text-green-400 mb-6 font-bold animate-fade-in drop-shadow-lg">
                Odvážíte se ho vyvolat? 3x vyslovte jeho jméno a připojte se k nám!
              </p>
              <div className="relative">
                <p className="text-4xl md:text-6xl text-green-300 mb-4 font-black animate-beetlejuice-pulse drop-shadow-2xl">
                  BEETLEJUICE, BEETLEJUICE, BEETLE…
                </p>
                <div className="absolute -top-2 -left-2 w-6 h-6 border-2 border-green-400 rounded-full animate-beetlejuice-glow"></div>
                <div className="absolute -bottom-2 -right-2 w-4 h-4 border border-green-500 rounded-full animate-beetlejuice-pulse"></div>
              </div>
            </div>

            {/* Registration Options */}
            <div className="grid md:grid-cols-3 gap-8 mb-12 items-stretch">
              {/* Option 1: Stezka záhrobím */}
              <div className="bg-gradient-to-br from-gray-900/90 to-gray-800/90 border-2 border-green-600 rounded-3xl p-8 shadow-2xl hover:shadow-green-500/20 transition-all duration-300 transform hover:-translate-y-1 flex flex-col h-full">
                <div className="text-center flex flex-col flex-grow">
                  <h4 className="text-2xl font-bold text-green-400 mb-4 drop-shadow-lg">
                    Stezka záhrobím s Beetlejuicem
                  </h4>
                  <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                    Vhodné pro mladší s doprovodem (registrujte celkový počet účastníků, tj. děti včetně dospělých). Délka trasy: ~ 30 min (podle odvahy)
                  </p>
                  <div className="mt-auto">
                    <Link
                      to="/reservations"
                      className="bg-green-600/20 border-2 border-green-500 rounded-xl px-6 py-3 text-lg text-green-400 font-bold hover:bg-green-600/30 hover:border-green-400 transition-all duration-300 shadow-2xl inline-block"
                    >
                      Rezervovat
                    </Link>
                  </div>
                </div>
              </div>

              {/* Option 2: Dům, kde šepot nezmizel */}
              <div className="bg-gradient-to-br from-gray-900/90 to-gray-800/90 border-2 border-green-600 rounded-3xl p-8 shadow-2xl hover:shadow-green-500/20 transition-all duration-300 transform hover:-translate-y-1 flex flex-col h-full">
                <div className="text-center flex flex-col flex-grow">
                  <h4 className="text-2xl font-bold text-green-400 mb-4 drop-shadow-lg">
                    Dům, kde šepot nezmizel
                  </h4>
                  <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                    Vhodné pro starší. Délka aktivity: ~ 10 min
                  </p>
                  <div className="mt-auto">
                    <Link
                      to="/reservations"
                      className="bg-green-600/20 border-2 border-green-500 rounded-xl px-6 py-3 text-lg text-green-400 font-bold hover:bg-green-600/30 hover:border-green-400 transition-all duration-300 shadow-2xl inline-block"
                    >
                      Rezervovat
                    </Link>
                  </div>
                </div>
              </div>

              {/* Option 3: Prokletá komnata */}
              <div className="bg-gradient-to-br from-gray-900/90 to-gray-800/90 border-2 border-green-600 rounded-3xl p-8 shadow-2xl hover:shadow-green-500/20 transition-all duration-300 transform hover:-translate-y-1 flex flex-col h-full">
                <div className="text-center flex flex-col flex-grow">
                  <h4 className="text-2xl font-bold text-green-400 mb-4 drop-shadow-lg">
                    Prokletá komnata
                  </h4>
                  <p className="text-gray-300 mb-6 leading-relaxed flex-grow">
                    Vhodné pro všechny, jak starší, tak mladší. Délka aktivity: ~ 5 min
                  </p>
                  <div className="mt-auto">
                    <Link
                      to="/reservations"
                      className="bg-green-600/20 border-2 border-green-500 rounded-xl px-6 py-3 text-lg text-green-400 font-bold hover:bg-green-600/30 hover:border-green-400 transition-all duration-300 shadow-2xl inline-block"
                    >
                      Rezervovat
                    </Link>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        {/* Creepy Floating Elements */}
        <div className="absolute top-20 left-10 w-20 h-20 border-2 border-green-500 rounded-full opacity-30 animate-beetlejuice-pulse"></div>
        <div
          className="absolute top-40 right-20 w-16 h-16 border-2 border-green-400 rounded-full opacity-40 animate-beetlejuice-pulse"
          style={{ animationDelay: "1s" }}
        ></div>
        <div
          className="absolute bottom-20 left-1/4 w-12 h-12 border-2 border-green-600 rounded-full opacity-35 animate-beetlejuice-pulse"
          style={{ animationDelay: "2s" }}
        ></div>
        <div className="absolute top-1/2 left-1/3 w-8 h-8 border border-green-400 rounded-full opacity-50 animate-beetlejuice-glow"></div>
      </section>


      <Footer />
    </div>
  );
};

export default HomePage;
